export default {
      id: "icon-title-h1-usage",
      viewBox: "0 0 75 49",
      url: "../icon/" + "icons.svg#icon-title-h1-usage",
      toString: function () {
        return this.url;
      }
    }